import "bootstrap/dist/css/bootstrap.min.css";
import DefaultRoutes from "./routes/routes";
import "./style/app.css";
import OfflineDetector from "./component/offlineDetector/offlineDetector";
import { getToken, onMessage } from "firebase/messaging";
import { useEffect, useState } from "react";
import { messaging } from "./firebase/firebase";
import MaintainceMode from "./component/maintainceMode/maintainceMode";
import axios from "axios";
import { AlreadyLoggedModal, MobileViewModal } from "./utils/modal";
import { initAppsFlyer } from "./component/appsflyer";

function App() {
  const [deviceToken, setdeviceToken] = useState(null);

  const [notification, setNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

   useEffect(() => {
     console.log("Called AppsFlyer")
    initAppsFlyer();
  }, []);

  axios.interceptors.response.use(
    function (response) {
      // If the response is successful, just return the response
      return response;
    },
    function (error) {
      // Check for 401 status code
      if (error.response && error.response.status === 401) {
        const url = error.config?.url || "";
        // Do not trigger global logout for public fantasy/contest lookup APIs
        if (!url.includes("fantasy-details") && !url.includes("contest-details")) {
          setIsModalOpen(true);
        }
      }
      // Reject the error so it can still be handled by .catch in the requests
      return Promise.reject(error);
    }
  );

  const closeModal = () => {
    setIsModalOpen(false);
    window.localStorage.removeItem("Token");
    window.location.href = "/";
  };

  useEffect(() => {
    const checkMobileView = () => {
      if (window.innerWidth <= 760) {
        setIsMobileModalOpen(true);
      }
    };

    checkMobileView(); // Run on initial load

    // Optional: Listen for window resize (in case user resizes manually)
    window.addEventListener("resize", checkMobileView);
    return () => {
      window.removeEventListener("resize", checkMobileView);
      setIsMobileModalOpen(false);
    };
  }, []);

  useEffect(() => {
    const requestPermission = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          if (messaging) {
            const token = await getToken(messaging, {
              vapidKey:
                "BMQM40fTulUqQGLXiIzTXAmLy8QR6RP3CiQMOco-WvoTo2vsK8W1xhxP6VSDX_3ECy7w0Np2BeGL0_gAAjinoxg",
            });
            if (token) {
              console.log("FCM Token:", token);
              localStorage.setItem("Device_Token", token);
              // window.localStorage.setItem("Device_Token", token);
              setdeviceToken(token);
            }
          }
        } else {
          console.log("Notification permission denied");
        }
      } catch (error) {
        console.log("Error requesting permission:", error);
      }
    };

    // getToken(messaging, {
    //   vapidKey:
    //     "BMQM40fTulUqQGLXiIzTXAmLy8QR6RP3CiQMOco-WvoTo2vsK8W1xhxP6VSDX_3ECy7w0Np2BeGL0_gAAjinoxg",
    // })
    //   .then((currentToken) => {
    //     if (currentToken) {
    //       console.log("Token retrieved successfully:", currentToken);
    //     } else {
    //       console.log(
    //         "No registration token available. Request permission to generate one."
    //       );
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Error retrieving token: ", err);
    //   });

    requestPermission();

    let unsubscribe = () => {};
    if (messaging) {
      unsubscribe = onMessage(messaging, (payload, error) => {
        console.log("Message received in foreground:", payload, error);
        
        if (payload?.data?.type === 'logout') {
          console.log("Logout notification received, logging out...");
          closeModal();
          return;
        }

        if (payload.notification) {
          setNotification({
            title: payload.notification.title || "",
            body: payload.notification.body || "",
            icon: "https://rallybulls.s3.ap-south-1.amazonaws.com/public/upload/web/Group+94090.svg",
          });
          // You can also use the browser's Notification API here if you want
          new Notification(payload.notification.title || "", {
            body: payload.notification.body,
            icon: "https://rallybulls.s3.ap-south-1.amazonaws.com/public/upload/web/Group+94090.svg",
          });
        }
      });
    }

    return () => {
      unsubscribe(); 
    };
  }, []);

  // async function requestPermissionq() {
  //   const permission = await Notification.requestPermission();

  //   console.log(77778888, permission);
  //   if (permission === "granted") {
  //     // Generate Token
  //     const token = await getToken(messaging, {
  //       vapidKey:
  //         "BMQM40fTulUqQGLXiIzTXAmLy8QR6RP3CiQMOco-WvoTo2vsK8W1xhxP6VSDX_3ECy7w0Np2BeGL0_gAAjinoxg",
  //     });
  //     window.localStorage.setItem("Device_Token", token);
  //     setdeviceToken(token);
  //     console.log("Token Gen", token);
  //     // Send this token  to server ( db)
  //   } else if (permission === "denied") {
  //     alert("You denied for the notification");
  //   }
  // }

  // useEffect(() => {
  //   // Req user for notification permission
  //   requestPermissionq();
  // }, []);

  // onMessage(messaging, (payload, error) => {
  //   console.log("Message received. ", payload, error);
  //   const { title, body } = payload.notification;

  //   console.log(41, Notification.permission);
  //   // Check if the browser supports notifications
  //   if (Notification.permission === "granted") {
  //     // Display the notification
  //     new Notification(title, {
  //       body: body,
  //       icon: "https://rallybulls.s3.ap-south-1.amazonaws.com/public/upload/web/Group+94090.svg",
  //     });
  //   } else {
  //     console.log("Notifications are not permitted.");
  //   }
  // });
  //

  return (
    <div className="App">
      <DefaultRoutes deviceToken={deviceToken} />
      <OfflineDetector />
      <MaintainceMode />
      {/* <div>
        {console.log("....", "notification", notification)}
        {notification && (
          <div className="fixed top-4 right-4 bg-white shadow-lg rounded-lg p-4 max-w-sm">
            <img
              src="https://rallybulls.s3.ap-south-1.amazonaws.com/public/upload/web/Group+94090.svg"
              alt="Notification Icon"
              className="w-10 h-10 rounded-full"
            />
            <h3 className="font-bold">{notification.title}</h3>
            <p>{notification.body}</p>
          </div>
        )}
      </div> */}
      {isModalOpen && (
        <AlreadyLoggedModal isActive={isModalOpen} onClose={closeModal} />
      )}
      {isMobileModalOpen && (
        <MobileViewModal
          isActive={isMobileModalOpen}
          onClose={() => setIsMobileModalOpen(false)}
        />
      )}
    </div>
    
  );
}

export default App;
